import React, { useState } from 'react'
import useWindowSize from '../../hooks/useWindowSize'
import ContentWithSelect from './ContentWithSelect'
import ContentWithTabs from './ContentWithTabs'

const TabbedContent = ({ data, isVertical = false, ...props }) => {
  const [currentData, setCurrentData] = useState(0)
  const windowSize = useWindowSize()

  return windowSize.width > 700 ? (
    <ContentWithTabs
      className="leshen-tabs content-with-tabs"
      data={data}
      isVertical={isVertical}
      {...props}
    />
  ) : (
    <ContentWithSelect
      className="leshen-tabs content-with-select"
      currentData={currentData}
      setCurrentData={setCurrentData}
      data={data}
    />
  )
}

export default TabbedContent
